import script from "./OrdenesServicio.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdenesServicio.vue?vue&type=script&setup=true&lang=js"

import "./OrdenesServicio.vue?vue&type=style&index=0&id=e8bfbcc0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8bfbcc0"]])

export default __exports__